/**
 * Shared post-login navigation for auth screens (T8.8 redirect-after-login).
 * Honors the deep link the user was trying to reach (stashed by RequireAuth in
 * location.state.from) but never sends a user across the persona boundary:
 * clients always land in the portal, agency roles always in the agency app.
 */

function isAgencyPath(pathname) {
  return !pathname.startsWith('/client') && !pathname.startsWith('/login');
}

export function destinationForSession(session, location) {
  const role = session?.role;
  const fallback = role === 'client' ? '/client/home' : '/approvals';
  const from = location.state?.from?.pathname;

  if (!from || from === '/login' || from === '/') return fallback;

  if (role === 'client') {
    return from.startsWith('/client') ? from : fallback;
  }

  return isAgencyPath(from) ? from : fallback;
}
